<template>
  <div>
    <ShippingInsurancesHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <ShippingInsurancesFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ShippingInsurancesTable
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import ShippingInsurancesHead from "./ShippingInsurancesHead/ShippingInsurancesHead";
  import ShippingInsurancesFilter from "./ShippingInsurancesFilter/ShippingInsurancesFilter";
  import ShippingInsurancesTable from "./ShippingInsurancesTable/ShippingInsurancesTable";

  export default {
    name: "ShippingInsurancesTableAdmin",

    components: {
      ShippingInsurancesHead,
      ShippingInsurancesFilter,
      ShippingInsurancesTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
